import React from 'react';
import { connect } from 'react-redux';
import StandardLayout from '../../../../../../components/Layout/StandardLayout';
import ReminderMessageTemplates from '../../../../../../components/Layout/AutoReminders/AutoReminderSettings/ReminderMessageTemplates';

const ROLEX_INQUIRY_TYPE = 'rolexInquiry';

const InquiryReminderMsgTemplate = props => {
  const { reminderId } = props.match.params;

  return (
    <StandardLayout
      title={`${props.msgTempAddOrEdit} Message Template for Auto Reminder`}
      description="Create message templates that appear with the auto reminder"
      breadCrumbs={[
        { title: 'Configuration' },
        { title: 'Rolex Inquiry', to: '/Configuration/rolex' },
        {
          title: 'Auto Reminder',
          to: `/Configuration/rolex/edit-auto-reminder/${reminderId}`,
        },
      ]}
      classProps="standard-width-with-sidebar"
    >
      <ReminderMessageTemplates
        popConfirmDesc="This will remove the template from this Reminder"
        cancelRoute={`/Configuration/rolex/edit-auto-reminder/${reminderId}`}
        type={ROLEX_INQUIRY_TYPE}
        match={props.match}
      />
    </StandardLayout>
  );
};

const mapStateToProps = state => ({
  ...state.auth,
  ...state.autoRemMsgs,
});

export default connect(mapStateToProps, {})(InquiryReminderMsgTemplate);
